import { __assign } from "tslib";
import { hasPlaceholder, RegionType } from '@wix/shoutout-email-model-v3';
import { get } from 'lodash';
import { addHttps } from '../../utils/add-https';
import * as cssUtils from '../../utils/css-utils';
import { getMessageWidth } from '../../utils/get-message-width';
import { getImageSrc, getImageWidth, isGif } from './image-utils';
var AVATAR_SIZE = 60;
export var getImageSection = function (_a) {
    var region = _a.region, composerData = _a.composerData, css = _a.css, replaceImagePlaceholders = _a.replaceImagePlaceholders;
    if (region.type !== RegionType.Image) {
        throw Error('Image must be passed');
    }
    var userOverrides = get(region, 'data.styles.region');
    var rules = [
        userOverrides,
        css['so-global-region-image'],
        css['so-global-region'],
    ];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    var padding = cssUtils.padding(rules);
    var margin = cssUtils.margin(rules);
    var messageContentWidth = getMessageWidth(composerData, css);
    var maxWidth = messageContentWidth -
        ((padding.left || 0) + (padding.right || 0)) -
        ((margin.left || 0) + (margin.right || 0));
    var src = getImageSrc({
        region: region,
        fallbackUrl: composerData.styles.settings.image.url,
        maxContentWidth: maxWidth,
        replaceImagePlaceholders: replaceImagePlaceholders,
    });
    // NOTE: This stores probable image dimensions for outlook and loader. They
    // might match rendered image if there is enough information to do it but
    // otherwise it might be wild guess.
    var probableWidth;
    var probableHeight;
    var width;
    var imageProps = {
        outerPadding: margin,
        innerPadding: padding,
    };
    var imgStyle = {};
    if (region.data.placeholderPreviewType === 'avatar') {
        probableWidth = AVATAR_SIZE;
        probableHeight = AVATAR_SIZE;
        width = AVATAR_SIZE.toString();
        imgStyle.borderRadius = '100%';
        imgStyle.height = AVATAR_SIZE + "px";
    }
    else {
        probableWidth = getImageWidth(region, maxWidth);
        width = isGif(src) ? probableWidth.toString() : 'auto';
        if (region.data.width && region.data.height) {
            probableHeight = (region.data.height * probableWidth) / region.data.width;
        }
        else {
            probableHeight = Math.floor(probableWidth / 1.6);
        }
    }
    var srcPlaceholder = region.data.relativeUri || region.data.url;
    return __assign(__assign({ src: addHttps(src), srcPlaceholder: hasPlaceholder(srcPlaceholder) ? srcPlaceholder : '', link: region.data.imageLink, probableWidth: probableWidth, probableHeight: probableHeight, width: width, cssClass: mobileCssClass }, imageProps), { imgStyle: imgStyle });
};
//# sourceMappingURL=get-image-section.js.map